// Utilidades para el "Nuevo precio de venta" editable de la vista Subsanar.

// Normaliza un valor de precio a número o null (cadenas vacías / no numéricas -> null).
export const toSalePriceNumber = (value) => {
  if (value == null || value === "") return null;
  const numeric = Number(value);
  return Number.isFinite(numeric) ? numeric : null;
};

// Construye el array `productos_asociados` del payload de subsanar.
// `salePrices` mapea rowKey -> valor editado; solo las filas cuyo precio cambió
// respecto al `resultado` original llevan la propiedad `valor_unitario_venta`.
export const buildProductosAsociadosPayload = (productos = [], salePrices = {}) =>
  productos.map((producto) => {
    const initial = toSalePriceNumber(producto?.resultado);
    const edited = producto?.rowKey in salePrices ? toSalePriceNumber(salePrices[producto.rowKey]) : undefined;
    const changed = edited !== undefined && edited != null && edited !== initial;

    const item = {
      id_orden_detalle: producto?.id_orden_detalle ?? null,
      id_producto: producto?.id_producto ?? null,
      nombre: producto?.nombre ?? "",
      precio_minimo: producto?.precio_minimo ?? null,
      precio_maximo: producto?.precio_maximo ?? null,
      valor_venta: producto?.valor_venta ?? null,
      categoria_alerta: producto?.categoria_alerta ?? { codigo: null, nombre: "" },
      resultado: producto?.resultado ?? "",
    };

    if (changed) item.valor_unitario_venta = edited;
    return item;
  });

// Construye el objeto `producto` del payload de subsanar para PRODUCTO INDETERMINADO
// (gestiona un único item). Toma el producto original y sobreescribe los campos
// editables del "Nuevo producto para el catálogo de la jornada".
export const buildProductoIndeterminadoPayload = (base = {}, form = {}) => ({
  id_orden_detalle: base?.id_orden_detalle ?? null,
  id_producto: base?.id_producto ?? null,
  nombre: (form?.nombre ?? "").trim(),
  unidad:
    form?.unidad?.value != null
      ? { id: form.unidad.value, name: form.unidad.label }
      : base?.unidad ?? null,
  marca: (form?.marca ?? "").trim(),
  especificacion_tecnica: (form?.especificacion_tecnica ?? "").trim(),
  precio_minimo: base?.precio_minimo ?? null,
  precio_maximo: base?.precio_maximo ?? null,
  valor_venta: base?.valor_venta ?? null,
  nuevo_valor_catalogo: base?.nuevo_valor_catalogo ?? base?.valor_catalogo ?? null,
  categoria_alerta: base?.categoria_alerta ?? { codigo: null, nombre: "" },
  resultado: base?.resultado ?? "",
});

// Construye el objeto `producto` del payload de gestionar (aprobación del Supervisor)
// para PRODUCTO INDETERMINADO. Mantiene los datos base del producto y adjunta los
// valores de mercado diligenciados en el recálculo de Sub. Operativa.
export const buildProductoGestionarPayload = (base = {}, values = {}, result = null) => ({
  id_orden_detalle: base?.id_orden_detalle ?? null,
  id_producto: base?.id_producto ?? null,
  nombre: base?.nombre ?? "",
  unidad: base?.unidad ?? null,
  marca: base?.marca ?? "",
  especificacion_tecnica: base?.especificacion_tecnica ?? "",
  precio_minimo: toSalePriceNumber(values?.precioMinimo),
  precio_maximo: toSalePriceNumber(values?.precioMaximo),
  valor_venta: toSalePriceNumber(values?.valorVentaNuevo),
  nuevo_valor_catalogo: toSalePriceNumber(values?.valorCatalogoNuevo),
  categoria_alerta: base?.categoria_alerta ?? { codigo: null, nombre: "" },
  resultado: result?.label ?? "",
});